import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BodyText, Flex } from "@utilitywarehouse/hearth-react";

import { ConfirmationAnswer } from "../../../context/vulnerability/VulnerabilityContext";
import WhyWeWant from "../../WhyWeWant";
import { QuestionsDataTest } from "../constants";
import NavigationButtons from "../NavigationButtons";
import MultiChoiceSelect from "../../MultiChoiceSelect";

export interface ConfirmationQuestionProps {
  step: string;
  title: string;
  subTitle?: string;
  onContinue: () => void;
  onBack?: () => void;
  whyWeWantTexts?: string[];
  value?: ConfirmationAnswer;
  onChange: (answer: ConfirmationAnswer) => void;
  requireAnswer?: boolean;
}

const ConfirmationQuestion: React.FC<ConfirmationQuestionProps> = ({
  step,
  title,
  subTitle,
  onContinue,
  whyWeWantTexts,
  value,
  onChange,
  onBack,
  requireAnswer,
}) => {
  const navigate = useNavigate();

  const [hasError, setHasError] = useState(false);

  const onContinueClick = () => {
    if (!value) {
      setHasError(true);
    } else {
      setHasError(false);
      onContinue();
    }
  };

  return (
    <Flex direction="column" gap="500">
      {step ? (
        <BodyText weight="semibold">
        {step}
        </BodyText>
      ) : null}

      <Flex direction="column" gap="150">
        <BodyText weight="semibold" data-testid={QuestionsDataTest.TITLE}>
          {title}

          {subTitle ? (
            <BodyText color="secondary" data-testid={QuestionsDataTest.SUB_TITLE}>
              {subTitle}
            </BodyText>
          ) : null}
        </BodyText>

        <MultiChoiceSelect
          value={value}
          requireAnswer={requireAnswer}
          onChange={onChange}
          hasError={hasError}
        />
      </Flex>

      {whyWeWantTexts ? (
        <WhyWeWant whyWeWantTexts={whyWeWantTexts} />
      ) : null}

      <NavigationButtons
        onBack={() => (onBack ? onBack() : navigate(-1))}
        onContinue={onContinueClick}
      />
    </Flex>
  );
};

export default ConfirmationQuestion;
